import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import FormActions from "../redux-react/actions/formAction";

/**
 * Custom hook to fetch and manage languages data
 * @param {boolean} autoFetch - Whether to automatically fetch languages on mount (default: true)
 * @returns {Object} - { languages, loading, error, refetchLanguages }
 */
export const useLanguages = (autoFetch = true) => {
	const [languages, setLanguages] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const dispatch = useDispatch();

	const fetchLanguages = () => {
		setLoading(true);
		setError(null);

		dispatch(
			FormActions.getItemsFromCollection(
				"language",
				{
					query: {
						label: { $in: [null, false] }
					},
					sort: {
						default: -1
					}
				},
				res => {
					try {
						const result = res.items;
						setLanguages(result);
						setLoading(false);
					} catch (err) {
						setError(err);
						setLoading(false);
					}
				}
			)
		);
	};

	useEffect(() => {
		if (autoFetch) {
			fetchLanguages();
		}
	}, [autoFetch]);

	return {
		languages,
		loading,
		error,
		refetchLanguages: fetchLanguages
	};
};

export default useLanguages;
